import React from 'react';
import { Link } from 'gatsby';
import logo from '../../../assets/resources/icon/logo-ulam-black.svg';
import ImageHtml from '../ImgHTML';

export default ({ layoutSetup }) => {
  const { withLink, mainText } = layoutSetup;

  return (
    <>
      {withLink && (
        <div className="side-beam-link">
          <Link to="/">&larr; Back to homepage</Link>
        </div>
      )}
      {mainText && (
        <div className="d-flex flex-column main-text-wrapper">
          <ImageHtml src={logo} className="contact-logo-black mb-4 " />
          <div className="logo-subtitle">Contact us</div>
          <h1 className="contact-main-header mt-5 d-none d-lg-block">
            Let’s see what we can create together
          </h1>
        </div>
      )}
    </>
  );
};
